import { createFileRoute } from '@tanstack/react-router'
import { ActiveManagement } from '../../pages'

export const Route = createFileRoute('/_layout/active-management')({
    component: ActiveManagement,
})
